import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2EditOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M27.973 26.03 26.593 28H4V4h18l-1.68 2H6v20h21.973zM25.975 24h2l.018-13.992-2.002 2.439zm-12.87-2.902 2.065-.857L28.05 5.36l-1.512-1.308-12.879 14.879z" /></svg>
);
